// /pricing (pages/pricing.js) and the plan card / plan button
// (components/pricing/PricingCard.js, whose PlanCTA the upgrade modal also
// uses). The page renders English on the server and switches on the client.
// See messages/README.md for how to add strings.
export const pricing = {
  en: {
    "pricing.promo": "Your first month from {price}",
    "pricing.title": "Make covers with any voice",
    "pricing.subtitle":
      "Unlimited covers, downloads and all 60,000+ voices. Cancel any time.",
    "pricing.trialLinkInvalid":
      "This free trial link is for a different account or has expired — regular checkout shown.",

    "pricing.basic.subtitle": "For making covers",
    "pricing.creator.subtitle": "For videos and your own voices",
    "pricing.power.subtitle": "For heavy use and developers",
    "pricing.badge.popular": "Most popular",

    "pricing.feature.unlimitedCovers": "Unlimited covers",
    "pricing.feature.download": "Download cover, vocals and music",
    "pricing.feature.library": "The full voice library",
    "pricing.feature.tts": "Text to speech",
    "pricing.feature.duets": "Duets",
    "pricing.feature.credits": "Credits never expire",
    "pricing.feature.train": "Train unlimited voices",
    "pricing.feature.videos": "Shareable videos: Marble Run and lyrics",
    "pricing.feature.coins50": "50 video coins every month",
    "pricing.feature.priority": "Priority processing, 250 per 12 hours",
    "pricing.feature.coinsUnlimited": "Unlimited video coins",
    "pricing.feature.api": "$25 of API credits every month",

    "pricing.compareAll": "Compare everything",
    "pricing.trust.cancel": "Cancel any time, keep what you made",
    "pricing.trust.stripe": "Secure checkout with Stripe",
    "pricing.trust.currency": "Prices in your currency",

    "pricing.compare.title": "Compare plans",
    "pricing.compare.noPlan": "No plan",
    "pricing.compare.browse": "Browse and hear every voice",
    "pricing.compare.covers": "Covers",
    "pricing.compare.downloads": "Downloads",
    "pricing.compare.ttsDuets": "Text to speech and duets",
    "pricing.compare.song": "Generate a song with AI",
    "pricing.compare.train": "Train your own voices",
    "pricing.compare.videos": "Videos (Marble Run, lyrics)",
    "pricing.compare.priority": "Priority processing",
    "pricing.compare.api": "API credits",
    "pricing.compare.unlimited": "Unlimited",
    "pricing.compare.coins50": "50 coins a month",
    "pricing.compare.priorityLimit": "250 per 12 hours",
    "pricing.compare.apiAmount": "$25 a month",

    "pricing.faq.title": "Questions",
    "pricing.faq.noPlan.q": "What can I do without a plan?",
    "pricing.faq.noPlan.a":
      "You can browse and listen to every voice on Jammable. Making covers, downloading them, text to speech and duets all need a plan.",
    "pricing.faq.basic.q": "What is included in the Basic plan?",
    "pricing.faq.basic.a":
      "The Basic plan includes unlimited covers, downloads, access to the full Jammable voice library, text to speech, duets, and your credits never expire.",
    "pricing.faq.creator.q": "How does the Creator plan differ from Basic?",
    "pricing.faq.creator.a":
      "The Creator plan offers everything in Basic plus the ability to train unlimited voices, create shareable videos, and 50 Marble Run coins per month.",
    "pricing.faq.power.q": "What makes the Power plan special?",
    "pricing.faq.power.a":
      "Power includes everything in Creator, plus priority processing (250/12hrs), unlimited Marble Run coins and $25 of API credits every month for professional creators.",
    "pricing.faq.cancel.q": "Can I cancel my subscription anytime?",
    "pricing.faq.cancel.a":
      "Yes, cancel at any time. Your benefits stay active until the end of your billing period.",
    "pricing.faq.change.q": "Can I upgrade or downgrade?",
    "pricing.faq.change.a":
      "Absolutely. Upgrade or downgrade whenever you like and your benefits update accordingly.",

    // components/pricing/PricingCard.js
    "pricing.card.perYear": "a year, about {price} a month",
    "pricing.card.firstMonthThen": "first month, then {price} a month",
    "pricing.card.perMonth": "a month",
    "pricing.card.startFor": "Start for {price}",
    "pricing.card.everythingIn": "Everything in {plan}, plus",
    "pricing.cta.get": "Get {plan}",
    "pricing.cta.yourPlan": "Your plan",
    "pricing.cta.manage": "Manage plan",
    "pricing.cta.upgradeTo": "Upgrade to {plan}",
    "pricing.cta.updated": "Your subscription has been updated!",
    "pricing.error.generic": "Something went wrong. Please contact support!",
    "pricing.seo.title": "Pricing | Jammable",
    "pricing.seo.description":
      "Jammable plans for making AI covers with any voice: unlimited covers, downloads and 60,000+ voices. Prices in your currency, cancel any time.",
  },
};
